export const HEADER_OFFSET = 64;

const easeInOutCubic = (t) => (t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2);
let rafId = 0;

export const sectionOf = (id) => {
  const el = document.getElementById(id);
  return el ? el.closest("section") || el : null;
};

export const scrollToId = (id, { updateHash = false } = {}) => {
  const el = sectionOf(id);
  if (!el) return;
  if (updateHash) window.history.replaceState(null, "", `#${id}`);
  const target = Math.max(0, el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET);
  const reduced = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  cancelAnimationFrame(rafId);
  if (reduced) { window.scrollTo(0, target); return; }
  const start = window.scrollY;
  const dist = target - start;
  const duration = Math.min(900, Math.max(700, Math.abs(dist) / 6));
  const t0 = performance.now();
  const step = (now) => {
    const p = Math.min(1, Math.max(0, (now - t0) / duration));
    window.scrollTo(0, start + dist * easeInOutCubic(p));
    if (p < 1) rafId = requestAnimationFrame(step);
  };
  rafId = requestAnimationFrame(step);
};

export const openDemo = () => {
  scrollToId("demo");
  window.setTimeout(() => document.getElementById("demo-name")?.focus({ preventScroll: true }), 900);
};
